export default "__VITE_ASSET__1e1aca63__"